import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { useResponsiveProp } from "../props/ResponsiveProp.js";
import { jsx as _jsx } from "react/jsx-runtime";
function computeFlexBasis(scale) {
  return "".concat(scale * 100, "%");
}
function flexBasisMixin(width) {
  switch (width) {
    case '1/2':
      return computeFlexBasis(1 / 2);
    case '1/3':
      return computeFlexBasis(1 / 3);
    case '2/3':
      return computeFlexBasis(2 / 3);
    case '1/4':
      return computeFlexBasis(1 / 4);
    case '3/4':
      return computeFlexBasis(3 / 4);
    case '1/5':
      return computeFlexBasis(1 / 5);
    case '2/5':
      return computeFlexBasis(2 / 5);
    case '3/5':
      return computeFlexBasis(3 / 5);
    case '4/5':
      return computeFlexBasis(4 / 5);
  }
  return 'auto';
}
function columnRootMixin(width) {
  return css(["flex-grow:0;flex-basis:", ";width:", ";flex-shrink:", ";"], flexBasisMixin(width), width === 'fluid' ? '100%' : 'auto', width === 'fluid' || width === 'adaptive' ? 1 : 0);
}
var ColumnRoot = /*#__PURE__*/styled.div.withConfig({
  displayName: "Column__ColumnRoot",
  componentId: "SD__sc-m9n6o6-0"
})(_ref => {
  var {
    theme,
    columnWidth
  } = _ref;
  return css(["min-width:0;", ";", "{", ";}", "{", ";}& > div{padding-top:var(--column-space-top);padding-left:var(--column-space-left);padding-bottom:var(--column-space-bottom);}&:last-child > div{padding-top:0;padding-bottom:0;}"], columnRootMixin(columnWidth[0]), theme.breakpoints.up('sm'), columnRootMixin(columnWidth[1]), theme.breakpoints.up('md'), columnRootMixin(columnWidth[2]));
});
export var Column = /*#__PURE__*/forwardRef((_ref2, ref) => {
  var {
    children,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    width = 'fluid'
  } = _ref2;
  var columnWidth = useResponsiveProp(width);
  return /*#__PURE__*/_jsx(ColumnRoot, {
    ref: ref,
    columnWidth: columnWidth,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    children: /*#__PURE__*/_jsx("div", {
      children: children
    })
  });
});
if (process.env.NODE_ENV !== "production") Column.displayName = "Column";